import React, { useState } from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCJudges.scss';
import { Card, CardImg } from 'reactstrap';
import PreviewImageAndClick from '../../../widgets/PreviewImageAndClick/PreviewImageAndClick';

const YDCJudges = (props) => {
  const { curLang, judgesList, title, judges_detail } = props;

  const [previewImgOpen, setPreviewImgOpen] = useState(false);
  const [selectImgIndex, setSelectImgIndex] = useState(0);
  const previewImgToggle = () => setPreviewImgOpen(!previewImgOpen);
  const selectImgIndexFun = (index) => setSelectImgIndex(index);

  const imageList = judgesList.map((item, index) => ({
    image: item.judges_images_upload,
  }));

  return (
    <>
      <PageTitle title={title} />
      <div className="ydc-judges">
        <div className="judges-card-grid">
          {imageList.map((item, index) => {
            // if (index === 8 || index === 11) {
            //   return <Card key={index} className="judges-card blank"></Card>;
            // }
            return item.image ? (
              <Card
                key={index}
                className="judges-card"
                onClick={() => {
                  selectImgIndexFun(index);
                  setPreviewImgOpen(true);
                }}
              >
                <div className="card-container">
                  <CardImg src={item.image} alt={`judges-image-${index}`} />
                  {(judges_detail?.[index]?.judges_title ||
                    judges_detail?.[index]?.judges_name ||
                    judges_detail?.[index]?.judges_post) && (
                    <div className="itemCaption">
                      <div className="title">{judges_detail[index].judges_title}</div>
                      <div className="description">{judges_detail[index].judges_name}</div>
                      <div className="description">{judges_detail[index].judges_post}</div>
                    </div>
                  )}
                </div>
              </Card>
            ) : null;
          })}
        </div>
      </div>
      <PreviewImageAndClick
        previewImgToggle={previewImgToggle}
        previewImgOpen={previewImgOpen}
        selectImgIndex={selectImgIndex}
        selectImgIndexFun={selectImgIndexFun}
        imageList={imageList}
      />
    </>
  );
};

export default YDCJudges;
